import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(public router: Router) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// add authorization header with jwt token if available
		const token = localStorage.getItem('access_token');
		if (token) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
					'Cache-control': 'no-cache, no-store',
					Pragma: 'no-cache',
				},
				withCredentials: true,
			});
		}

		return next.handle(request);

		// ---- Errors are currently being handled in the error.interceptor.ts file

		// return next.handle(request).pipe(
		//   tap(
		//     (event: HttpEvent<any>) => {
		//       if (event instanceof HttpResponse) {
		//         // Handle successful responses
		//       }
		//     },
		//     (err: any) => {
		//       // Handle failed responses
		//       if (err instanceof HttpErrorResponse) {
		//         if (err.status === 401) {
		//           this.router.navigate(['login']);
		//         }
		//       }
		//     }
		//   )
		// );
	}
}
